export const getBetaEnvironmentInfo = () => {
  const BETA = 'beta';
  const url = window.location.href;
  const isBeta = url.includes(BETA);
  return isBeta;
};
